import React from "react";
import "./SizeGuid.css"
import { Link, useLocation } from "react-router-dom";


const SizeGuid = () => {
  const location = useLocation();
  const { id} = location.state
  const sizeData = [
    {
      category: "Shirt",
      columns: ["Size", "Chest", "Shoulder", "Stomach", "Bottom", "Sleeve", "Cuff", "Armhole"],
      sizes: [
        { size: "M", chest: "20 ½”", shoulder: "17 ½”", stomach: "20”", bottom: "21 ½”", sleeve: "25”", cuff: "9 ½”", armhole: "10”" },
        { size: "L", chest: "21 ½”", shoulder: "18 ½”", stomach: "21”", bottom: "22”", sleeve: "25 ½”", cuff: "10”", armhole: "11”" },
        { size: "XL", chest: "23”", shoulder: "19”", stomach: "22”", bottom: "23 ½”", sleeve: "29”", cuff: "11”", armhole: "11 ½”" },
        { size: "XXL", chest: "24”", shoulder: "19 ½”", stomach: "23”", bottom: "24”", sleeve: "30”", cuff: "11 ½”", armhole: "12”" },
      ],
    },
    {
      category: "Jacket",
      columns: ["Size", "Chest", "Length", "Shoulder", "Sleeve Length"],
      sizes: [
        { size: "S", chest: "38”", length: "26”", shoulder: "17”", sleeve: "23”" },
        { size: "M", chest: "40”", length: "27”", shoulder: "18”", sleeve: "24”" },
        { size: "L", chest: "42”", length: "28”", shoulder: "19”", sleeve: "25”" },
        { size: "XL", chest: "44”", length: "29”", shoulder: "20”", sleeve: "26”" },
        { size: "XXL", chest: "46”", length: "30”", shoulder: "21”", sleeve: "27”" },
      ],
    },
    {
      category: "Hoodie",
      columns: ["Size", "Chest", "Length", "Shoulder"],
      sizes: [
        { size: "M", chest: "46”", length: "30”", shoulder: "21”" },
        { size: "L", chest: "48”", length: "31”", shoulder: "22”" },
        { size: "XL", chest: "50”", length: "32”", shoulder: "23”" },
        { size: "XXL", chest: "52”", length: "32”", shoulder: "24”" },
      ],
    },
    {
      category: "Jeans",
      columns: ["Size", "Waist", "Hip", "Thigh", "Inseam", "Outseam"],
      sizes: [
        { size: "S", waist: "30”", hip: "40”", thigh: "24”", inseam: "30”", outseam: "40”" },
        { size: "M", waist: "32”", hip: "42”", thigh: "25”", inseam: "31”", outseam: "41”" },
        { size: "L", waist: "34”", hip: "44”", thigh: "26”", inseam: "32”", outseam: "42”" },
        { size: "XL", waist: "36”", hip: "46”", thigh: "27”", inseam: "32”", outseam: "42”" },
        { size: "XXL", waist: "38”", hip: "50”", thigh: "-", inseam: "37”", outseam: "42”" },
      ],
    },
  ];

  return (
    <div className="size-guide-container">
        <div className="guide-container">
           Back to  <Link to="/">Home</Link> {" / "}
            <Link to={`/product/${id}`}>  {" "}Product Page</Link>
            </div>
        
      <h2 className="size-guide-title">Size Guide</h2>
      {sizeData.map((item, index) => (
        <div key={index} className="size-guide-section">
          <h3 className="size-category">{item.category}</h3>
          <div className="size-table">
            <div className="size-row header">
              {item.columns.map((col, i) => (
                <div key={i}>{col}</div>
              ))}
            </div>
            {item.sizes.map((size, i) => (
              <div key={i} className="size-row">
                {Object.values(size).map((value, j) => (
                  <div key={j}>{value}</div>
                ))}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default SizeGuid;
